import React, { useContext } from 'react';
import { SmallBodySemiBold } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const ShiftAggregateRenderer = ({ rowData: { shift } }) => {
  const { t } = useContext(ConfigContext);

  return (
    <SmallBodySemiBold>
      {shift} {t('shifts')}
    </SmallBodySemiBold>
  );
};

export default ShiftAggregateRenderer;
